import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PageTitle } from '@app/common/page-layout/page-title';
import { ProfilesAdminBody } from './profiles-admin-body';
export default function ProfilesAdminPage() {
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Profiles" }), _jsx(ProfilesAdminBody, {})] }));
}
